import { key_func_type, response_type_internal } from './function/interfaces';
import { response_type } from './http-func';
import WebWorkerDB from './webworker-db';

export function get_db(key_func: key_func_type | key_func_type[], no_sorting?: 1, no_underlined_key?: 1): Promise<unknown | undefined> {
  return new Promise((resolve: (value?: unknown) => void) => {
    Array.isArray(key_func) && (key_func = key_func.filter(({ data }) => !data));
    const db_worker: WebWorkerDB = new WebWorkerDB(
      Array.isArray(key_func) ? key_func.map(({ post_process }: key_func_type) => post_process?.toString() || 'undefined') : key_func.post_process?.toString()
    );
    db_worker.postMessage(
      JSON.stringify([0, /** store_name */ Array.isArray(key_func) ? key_func.map(({ key }: key_func_type) => key) : key_func.key, no_sorting, no_underlined_key])
    );

    const listener: Function = (e: MessageEvent): void => {
      db_worker.removeEventListener('message', listener);
      let data: response_type = {} as response_type;

      try {
        data = JSON.parse(e.data);
      } catch {
        data = e.data;
      } finally {
        Array.isArray(key_func)
          ? key_func.forEach(({ func }: key_func_type, index: number) => {
              func?.(((data as unknown) as (response_type_internal | undefined)[] | undefined)?.[index]);
            })
          : key_func.func?.(data);
        resolve(data);
      }
    };

    db_worker.addEventListener('message', listener);
  });
}

export function set_db(db_name: string, value: any) {
  const db_worker: WebWorkerDB = new WebWorkerDB();
  db_worker.postMessage(JSON.stringify([1, db_name, value]));
}

export function delete_db(db_name: string | string[]) {
  const db_worker: WebWorkerDB = new WebWorkerDB();
  db_worker.postMessage(JSON.stringify([2, db_name]));
}
